import React, { createContext, useState, useContext, useEffect } from 'react';
import axios from 'axios';

const AuthContext = createContext(null);

// API 基础路径 - 自动适配部署路径（支持子目录如 /license/）
const getBasePath = () => {
  const path = window.location.pathname;
  // 如果路径包含 /activate，使用 /api（统一走根路径）
  if (path.includes('/activate')) {
    return '/api';
  }
  return '/api';
};
const API_BASE_URL = getBasePath();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [userType, setUserType] = useState(null);  // 'admin' 或 'customer'
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // 检查本地存储的token
    const token = localStorage.getItem('token');
    const savedUserType = localStorage.getItem('userType');
    if (token) {
      verifyToken(token);
    } else {
      setLoading(false);
    }
  }, []);

  const verifyToken = async (token) => {
    try {
      const response = await axios.get(`${API_BASE_URL}/auth/verify`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      if (response.data.success) {
        setUser(response.data.data.user);
        setUserType(response.data.data.user_type);
        localStorage.setItem('userType', response.data.data.user_type);
      } else {
        localStorage.removeItem('token');
        localStorage.removeItem('userType');
      }
    } catch (error) {
      localStorage.removeItem('token');
      localStorage.removeItem('userType');
    } finally {
      setLoading(false);
    }
  };

  // Admin 登录
  const login = async (username, password) => {
    try {
      const response = await axios.post(`${API_BASE_URL}/auth/login`, {
        username,
        password
      });
      
      if (response.data.success) {
        const { access_token, user, user_type } = response.data.data;
        localStorage.setItem('token', access_token);
        localStorage.setItem('userType', user_type);
        setUser(user);
        setUserType(user_type);
        return { success: true, user_type };
      }
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || '登录失败'
      };
    }
  };

  // 客户登录
  const customerLogin = async (username, password) => {
    try {
      const response = await axios.post(`${API_BASE_URL}/auth/customer/login`, {
        username,
        password
      });
      
      if (response.data.success) {
        const { access_token, user, user_type } = response.data.data;
        localStorage.setItem('token', access_token);
        localStorage.setItem('userType', user_type);
        setUser(user);
        setUserType(user_type);
        return { success: true, user_type };
      }
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || '登录失败'
      };
    }
  };

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('userType');
    setUser(null);
    setUserType(null);
  };

  const getAuthHeaders = () => {
    const token = localStorage.getItem('token');
    return token ? { Authorization: `Bearer ${token}` } : {};
  };

  return (
    <AuthContext.Provider value={{ 
      user, 
      userType,
      login, 
      customerLogin,
      logout, 
      loading, 
      getAuthHeaders, 
      API_BASE_URL,
      setUser
    }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
